__turbopack_context__.v({
  "contentOverlay": "VideoSection-module__BSnyYG__contentOverlay",
  "heading": "VideoSection-module__BSnyYG__heading",
  "sectionWrapper": "VideoSection-module__BSnyYG__sectionWrapper",
  "watchButton": "VideoSection-module__BSnyYG__watchButton",
});
